export const cssVariables = {
  borderRadius: 4,
};
